import { Alert, Box } from '@mui/material';
import React from 'react';
const INFO_PARSE_CODES = ['matched_by_meter_id'];
const renderMessages = messages => /*#__PURE__*/React.createElement(Box, {
  sx: {
    maxHeight: 160,
    overflowY: 'auto'
  }
}, messages.map((warning, idx) => /*#__PURE__*/React.createElement("div", {
  key: idx
}, warning.rowIndex > 0 ? "Row ".concat(warning.rowIndex, ": ").concat(warning.message) : warning.message)));
export const ParseWarnings = _ref => {
  let warnings = _ref.warnings;
  if (warnings.length === 0) return null;
  const infos = warnings.filter(w => INFO_PARSE_CODES.includes(w.code));
  const problems = warnings.filter(w => !INFO_PARSE_CODES.includes(w.code));
  return /*#__PURE__*/React.createElement(React.Fragment, null, problems.length > 0 && /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    sx: {
      mb: 2
    }
  }, renderMessages(problems)), infos.length > 0 && /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    sx: {
      mb: 2
    }
  }, renderMessages(infos)));
};